import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import isEqual from 'fast-deep-equal';

import { isEmpty, isNotDefined } from '@hsp/utilities';

import { useAppDispatch, useAppSelector } from 'hooks/store';
import { sharedABQueryKeys } from 'pages/audience/shared';
import { AudienceActions } from 'store/actions';
import { selectAudienceDefaultFieldValues } from 'store/selectors';
import { IAudienceBuilderSharedState } from 'types/store/audience-builder';

export const useReset = () => {
  const dispatch = useAppDispatch();
  const defaultValues = useAppSelector(selectAudienceDefaultFieldValues, isEqual);
  const queryClient = useQueryClient();

  return useCallback(
    (...ignoreKeys: (keyof IAudienceBuilderSharedState)[]) => {
      if (isNotDefined(defaultValues) || isEmpty(defaultValues)) {
        return;
      }

      queryClient.removeQueries({
        queryKey: sharedABQueryKeys.results.all,
      });

      dispatch(AudienceActions.clear(ignoreKeys));
      dispatch(AudienceActions.clearAggregate());
      dispatch(AudienceActions.clearCart());
    },
    [defaultValues, dispatch, queryClient]
  );
};
